import { makeStyles, Theme, createStyles } from "@material-ui/core";

export default makeStyles((theme: Theme) => {
  return createStyles({
    autocompleteInputRoot: {
      borderWidth: 1,
      borderColor: theme.palette.common.white,
      borderStyle: "solid",
      outline: "none",
      color: theme.palette.common.white,
    },
    autocompletClearIndicator: {
      color: theme.palette.common.white,
    },
    tableRow: {
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
    },
    stickyHeader: {
      backgroundColor: "transparent",
    },
    imageView: {
      "&:hover": {
        cursor: "pointer",
      },
    },
  });
});
